var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"singularity-canvas-add-section-button",on:{"click":_vm.addSection}},[_vm._v(" Add Section ")])
}
var staticRenderFns = []

export { render, staticRenderFns }